'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactAutosuggest = require('react-autosuggest');var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
var _match = require('autosuggest-highlight/match');var _match2 = _interopRequireDefault(_match);
var _parse = require('autosuggest-highlight/parse');var _parse2 = _interopRequireDefault(_parse);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _constants = require('../../../constants');
var _OMAutocompleteInput = require('./OMAutocompleteInput.scss');var styles = _interopRequireWildcard(_OMAutocompleteInput);
var _historySearchIcon = require('../../../../static/icons/history-search-icon.svg');var _historySearchIcon2 = _interopRequireDefault(_historySearchIcon);
var _locationInputIcon = require('../../../../static/icons/location-input-icon.svg');var _locationInputIcon2 = _interopRequireDefault(_locationInputIcon);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var updatedLocations = function updatedLocations(location) {return location.replace(/,\s*(Israel|Израиль|ישראל|Israël)/i, '');};var

OMAutocompleteInput = function (_Component) {_inherits(OMAutocompleteInput, _Component);
  function OMAutocompleteInput(props) {_classCallCheck(this, OMAutocompleteInput);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.






















    onChange = function (event, _ref) {var newValue = _ref.newValue,method = _ref.method;
      if (method === 'type') {
        _this.setState({
          value: newValue,
          autoFocus: true });

      } else if (method === 'up' || method === 'down') {
        _this.setState({ autoFocus: false });
      }
    };_this.

    onKeyDown = function (event) {
      if (event.keyCode === _constants.enterKey) {
        event.preventDefault();
      }
    };_this.

    onKeyUp = function () {
      clearTimeout(_this.props.deferRequestBy);
      setTimeout(function () {
        _this.props.getInputValue(_this.state.value);
      }, _this.props.deferRequestBy);
    };_this.

    onFocus = function (event) {
      _this.setState({ autoFocus: false });
      event.target.select();
    };_this.

    onBlur = function (event) {
      if (_this.props.isDeferredBlur) {
        event.persist();
        setTimeout(function () {
          if (_this.shouldHandleBlur && _this.props.onBlur) {
            _this.props.onBlur(event);
          } else {
            _this.shouldHandleBlur = true;
          }
        }, 0);
      } else if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };_this.

    onSuggestionSelected = function (event, _ref2) {var suggestionValue = _ref2.suggestionValue,suggestion = _ref2.suggestion,method = _ref2.method;
      event.nativeEvent.preventDefault();
      _this.setState({
        value: suggestionValue },
      function () {return _this.props.selectedSuggestion(suggestion, method);});
    };_this.

    getSuggestionValue = function (suggestion) {
      var address = suggestion.description ? Object.assign({},
      suggestion, {
        description: updatedLocations(suggestion.description) }) : Object.assign({},

      suggestion, {
        address: updatedLocations(suggestion.address) });


      return _this.props.getSuggestionValue(address) || (address ? address.value : null);
    };_this.

    shouldRenderSuggestions = function (value) {return value.trim().length > 1;};_this.

    clearInputLocation = function () {
      _this.shouldHandleBlur = false;

      if (_this.props.clearInput) {
        _this.props.clearInput();
      }

      _this.setState({
        value: '',
        suggestions: [],
        autoFocus: false });

    };_this.

    updatedSuggestions = function (suggestions) {return (
        suggestions && suggestions.map(function (location) {
          if (location.description) {
            return Object.assign({},
            location, {
              description: updatedLocations(location.description) });

          }

          return Object.assign({},
          location, {
            address: updatedLocations(location.address) });

        }));};_this.


    renderSuggestions = function (suggestion, _ref3) {var query = _ref3.query;
      if (query.indexOf('״') !== -1) {
        suggestion.description = suggestion.description.replace(/"/g, '״');
      }
      if (query.indexOf('׳') !== -1) {
        suggestion.description = suggestion.description.replace(/'/g, '׳');
      }
      var suggestionText = '' + suggestion.description;
      var formattedQuery = query.replace(/-/g, ' ');
      var matches = (0, _match2.default)(suggestionText, formattedQuery);
      var parts = (0, _parse2.default)(suggestionText, matches);

      parts.forEach(function (part, idx) {
        part.id = idx;
      });

      return (
        _react2.default.createElement('div', { className: 'suggestion-field' },
          _react2.default.createElement('span', { className: 'suggestion-icon' },
            _react2.default.createElement('img', { alt: 'autocompleteIcon', src: suggestion.isSearchHistory ? _historySearchIcon2.default : _locationInputIcon2.default })),

          _react2.default.createElement('span', null,

            parts.map(function (part) {return (
                part.highlight ?
                _react2.default.createElement('strong', { key: 'suggestion_' + part.id }, part.text) :
                _react2.default.createElement('span', { key: 'suggestion_' + part.id }, part.text));}))));





    };_this.

    renderClearButton = function () {return _this.props.clearable && _this.state.value &&
      _react2.default.createElement('span', { onClick: _this.clearInputLocation, className: 'icon icon-clear' });};_this.shouldHandleBlur = !!_this.props.onBlur;_this.state = { suggestions: [], value: props.initialValue || '', autoFocus: true || _this.props.autoFocus };return _this;}OMAutocompleteInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref4) {var initialValue = _ref4.initialValue,inputValue = _ref4.inputValue,allowEmptyInput = _ref4.allowEmptyInput,сlearInputLocation = _ref4.сlearInputLocation;if (this.props.initialValue !== initialValue) {this.setState({ value: initialValue });} else {var value = inputValue;if ((allowEmptyInput || value) && value !== this.props.inputValue) {this.setState({ value: value });}}if (сlearInputLocation !== this.props.сlearInputLocation && сlearInputLocation) {this.setState({ value: '' });}};OMAutocompleteInput.prototype.

  render = function render() {
    var inputProps = {
      name: this.props.inputName || 'SearchInput',
      value: updatedLocations(this.state.value) || '',
      placeholder: this.props.placeholder,
      className: this.props.isValid ? 'form-control' : 'form-control not_valid',
      onKeyDown: this.props.onKeyDown || this.onKeyDown,
      onFocus: this.props.onFocus || this.onFocus,
      onChange: this.props.onChange || this.onChange,
      onBlur: this.onBlur,
      onKeyUp: this.onKeyUp };


    var autosuggest =
    _react2.default.createElement(_reactAutosuggest2.default, {
      theme: this.props.theme,
      shouldRenderSuggestions: this.props.shouldRenderSuggestions || this.shouldRenderSuggestions,
      suggestions: this.updatedSuggestions(this.props.suggestions || this.state.suggestions),
      getSuggestionValue: this.getSuggestionValue,
      renderSuggestion: this.props.renderSuggestions || this.renderSuggestions,
      onSuggestionSelected: this.props.onSuggestionSelected || this.onSuggestionSelected,
      focusInputOnSuggestionClick: !this.props.isMobile,
      inputProps: inputProps,
      focusFirstSuggestion: this.state.autoFocus,
      title: this.state.value });



    if (this.props.isPublishAutocomplete) {
      return autosuggest;
    }
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.inputWrapper, this.props.className) },
        autosuggest,
        this.renderClearButton()));


  };return OMAutocompleteInput;}(_react.Component);


OMAutocompleteInput.propTypes = {
  isMobile: _propTypes2.default.bool,
  initialValue: _propTypes2.default.string,
  inputValue: _propTypes2.default.string,
  placeholder: _propTypes2.default.any,
  theme: _propTypes2.default.object,
  shouldRenderSuggestions: _propTypes2.default.func, // Specific func which return bool. Default: render suggestion when value lengths > 2
  suggestions: _propTypes2.default.array, // Default []
  renderSuggestions: _propTypes2.default.func, // Use your imagination to define how suggestions are rendered.
  getSuggestionValue: _propTypes2.default.func, // Function which return specific suggestion value (path to value of sug)
  getInputValue: _propTypes2.default.func, // Return current value of input . Triggered when onChange input action run
  selectedSuggestion: _propTypes2.default.func, // function to return selected suggestion
  onSuggestionSelected: _propTypes2.default.func,
  isValid: _propTypes2.default.bool,
  clearable: _propTypes2.default.bool,
  clearInput: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onChange: _propTypes2.default.func, // action when some suggestion selected
  deferRequestBy: _propTypes2.default.number.isRequired,
  autoFocus: _propTypes2.default.bool, // delay between answer,
  className: _propTypes2.default.string,
  isPublishAutocomplete: _propTypes2.default.bool,
  inputName: _propTypes2.default.string,
  isDeferredBlur: _propTypes2.default.bool,
  allowEmptyInput: _propTypes2.default.bool,
  сlearInputLocation: _propTypes2.default.bool,
  isProfessionals: _propTypes2.default.bool };exports.default =


OMAutocompleteInput;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMAutocompleteInput/OMAutocompleteInput.js
// module id = 272
// module chunks = 0